import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPieSkeletonQuarter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 106,
	height: 150,
	viewBox: "0 0 106 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.6652 148.371C14.0912 150.787 7.5568 148.238 5.70938 142.45C1.44351 129.087 -0.237218 114.996 0.795788 100.939C2.09822 83.2143 7.67577 66.0695 17.0511 50.9716C26.4264 35.8736 39.3203 23.2719 54.6293 14.2452C66.7714 7.08582 80.146 2.34435 94.0157 0.242138C100.022 -0.668265 105.204 4.05841 105.51 10.1258C105.817 16.1932 101.124 21.2903 95.1417 22.3505C84.8221 24.1797 74.8821 27.8431 65.8034 33.1962C53.5563 40.4176 43.2411 50.4988 35.7409 62.5772C28.2406 74.6556 23.7786 88.3715 22.7366 102.551C21.9642 113.062 23.0883 123.596 26.0248 133.656C27.7269 139.488 25.2393 145.955 19.6652 148.371Z",
		fill: "#F0EEED"
	})]
});
const ForwardRef = forwardRef(SvgPieSkeletonQuarter);
export { ForwardRef as ReactComponent };
